import { render } from "./update_rate.vue?vue&type=template&id=167c653c&scoped=true"
import script from "./update_rate.vue?vue&type=script&lang=js"
export * from "./update_rate.vue?vue&type=script&lang=js"

import "./update_rate.vue?vue&type=style&index=0&id=167c653c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167c653c"]])

export default __exports__